import styles from '../index.module.scss'
import { ContentUnavailable } from '../ContentUnavailable'
import { NewsSkeletons } from './NewsSkeletons'
import { Carousel } from 'react-bootstrap'
import { HomePageItem } from '../HomePage'
import { NewsRow } from './NewsRow'

const TFB_NEWS_URL = 'https://t4b.com/news/'

interface NewsProps {
    isLoading: boolean
    isError: boolean
    news: Array<HomePageItem[]>
}

export const News = (props: NewsProps) => {
    const { isError, isLoading, news } = props
    return (
        <div className="d-flex flex-column mt-3">
            <h2 style={{ marginBottom: '2px !important' }}>News</h2>
            <div className={`${styles.contentBox} p-4 pb-1`}>
                {isLoading ? (
                    <NewsSkeletons />
                ) : isError || !news.length ? (
                    <ContentUnavailable
                        link={TFB_NEWS_URL}
                        linkDisplayNameId="homePage.newsLink"
                        textMessageId="homePage.newsUnavailable"
                    />
                ) : (
                    <Carousel
                        controls={false}
                        className='pb-1'
                    >
                        {!!news?.length &&
                            news.map((newsItems, idx) => (
                                <Carousel.Item key={idx.toString()}>
                                    <NewsRow newsItems={newsItems} />
                                </Carousel.Item>
                            ))}
                    </Carousel>
                )}
            </div>
        </div>
    )
}
